import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { upflowIframeComponentEntrypoint } from './entrypoint.tsx';
import { useUpflowModal } from './controllers/index.tsx';

const entryPointParams = {};
const props = {};
export const AsyncUpflowIframeComponent = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		upflowIframeComponentEntrypoint,
		entryPointParams,
	);

	const [{ renderUpflowModal }] = useUpflowModal();

	// Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (renderUpflowModal) {
			entryPointActions.load();
		}
	}, [entryPointActions, renderUpflowModal]);

	return (
		<JiraEntryPointContainer
			id="issue-onboarding-modal-lazy"
			packageName="AsyncUpflowIframeComponent"
			placeholderName="async-upflow-iframe-modal"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={null}
			runtimeProps={props}
		/>
	);
};
